export default {
    RECURSO: 'recurso',
    CONTRARRAZAO: 'contrarrazao'
}